import { includes, pipe } from "ramda";

import { EXTENSIONS_WHITELIST } from "./enums";

const validateFileList = (files: FileList) =>
  files.length > 0 ? files : false;

const convertToArray = (files: FileList | false) => (files ? [...files] : []);

const validateExtension = (files: Array<File>) =>
  files.filter(({ type }: { type: string }) =>
    includes(type, EXTENSIONS_WHITELIST)
  );

export const validateAndConvertFilesToBlob = pipe(
  validateFileList,
  convertToArray,
  validateExtension
);
